import type { SearchAIAnswerQueryType } from '@atlassian/search-ai';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { SelectionRect } from '../src/CurrentSelectionSpan.tsx';
import type { ReadingAidsMode, SmartLinkSummarizeInvokedFrom } from '../src/ReadingAidsPopup.tsx';

type ReadingAidsPopupProps = {
	selectedText: string;
	additionalContext?: string;
	selectionRange?: Range;
	selectionRect: SelectionRect | null;
	onResult: (result: SearchAIAnswerQueryType) => void;
	onLoad?: () => void;
	isReadingAidsOpen: boolean;
	onClose: () => void;
	contentId: string;
	popupPortalContainerId: string;
	isAutohighlighted?: boolean;
	isEditor?: boolean;
	sessionId?: string;
	mode?: ReadingAidsMode;
	smartlinkUrl?: string;
	sourceProduct?: string | null;
	has3pSources?: boolean;
	invokedFrom?: SmartLinkSummarizeInvokedFrom;
};

type LoadedReadingAidsPopup = typeof import('../src/ReadingAidsPopup.tsx').ReadingAidsPopup;

export const ReadingAidsPopup: LoadableType<ReadingAidsPopupProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-readingAidsPopup" */ '../src/ReadingAidsPopup.tsx'
			)
		).ReadingAidsPopup,
	name: 'ReadingAidsPopup',
});

export const prepareSmartLinkSummarizePopup = async (): Promise<void> => {
	const popup = await ReadingAidsPopup.preload();
	if (typeof popup === 'function') {
		await (popup as LoadedReadingAidsPopup).preloadSummaryContent();
	}
};
